import axios from 'axios';
import {
  MDBAlert,
  MDBAnimation,
  MDBBadge,
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBRow,
  MDBSpinner,
  MDBTypography
} from 'mdb-react-ui-kit';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import ContactModal from "../contacts/ContactModal";
import { CartContext } from '../context/CartProvider';
import { CategoryContext } from '../context/CategoryContext';
import { GeographyContext } from '../context/GeographyProvider';
import { MiscContext } from '../context/MiscProvider';
import { NavbarContext } from '../context/NavProvider';
import { UserProfileContext } from '../context/UserProfileProvider';
import AddNewEntity from '../entity/AddNewEntity';
import ItemView from '../products/ItemView';
import Testimonials from '../testimonials/Testimonials';
import { fetchIPAddress } from '../utils/Common';
const ExpensesLanding = () => {
  const { isSubscribe } = useParams();
  const { setContactPage, contactPage} = useContext(MiscContext);
  const {ipAddress,location,currencies,country,setIPAddress} = useContext(GeographyContext);
  const {tokenLoaded} = useContext(UserProfileContext);
  const {setCategoryId,categoryData, setCategoryData} = useContext(CategoryContext);
    const { qty, setQty,setCartId, setAddedEntities,setCartCount, cartId} = useContext(CartContext);
    const { isPricing,  setIsPricing,pageData,setPageData} = useContext(NavbarContext);
  const [isPageDataEmpty, setIsPageDataEmpty] = useState(true);
  const baseUrl = process.env.REACT_APP_INVENTORY_URL;

  const [selectedItemId, setSelectedItemId] = useState(null);
  const getUnitByCountry = useCallback((countryObj) => {
    const countryName = countryObj?.country?.toLowerCase(); // Convert to lowercase
    console.log("Searching for:", countryName); // Debug line

    const currency = currencies.find(currency => currency?.country?.toLowerCase() === countryName); // Convert each country name to lowercase before comparing
    console.log("Found currency:", currency); // Debug line

    return currency ? currency.unit : null;
  }, [currencies]);
  const [isCarouselOpen, setIsCarouselOpen] = useState(false);
  const [units, setUnits] = useState();
  const [weight, setWeight] = useState({});
  const sectionRef = useRef(null);
  const [position, setPosition] = useState('top-center');
  const [alertForeCartItemAdded, setAlertForeCartItemAdded] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const delayOfAnimation = 5000;
  useEffect(() => {
    const fetchData = async () => {
      if (!ipAddress || ipAddress === 'undefined') {
        await fetchIPAddress(setIPAddress);
      }
    };
    fetchData();
  }, [ipAddress, setIPAddress]);
  
  useEffect(() => {
  
    const fetchPageData = async () => {

     
      try {
        const res = await axios.get(`${baseUrl}/mainpagedata`);
        setIsPageDataEmpty(false);
        localStorage.setItem('LOGO', res?.data?.logo);
        setPageData(res.data);
        setIsPricing(res.data.isPricing);
      } catch (error) {
        console.error("Page data not found in Mongo DB", error);
        setIsPageDataEmpty(true);
      }
    }

    if (!pageData) {
      fetchPageData();
    } else {
      setIsPageDataEmpty(false);
    }
  }, []);

  useEffect(() => {

    const unit = getUnitByCountry({ country });
    setUnits(unit);
    if (cartId) {
      console.log("Cart ID has been updated:", cartId);
      // Your code that relies on cartId being updated goes here
    }
  }, [cartId, country, getUnitByCountry]);

  const { categoryId } = useParams();

  // Set categoryId to either the value from useParams() or defaultCategoryId
  const selectedCategoryId = 'pricing';

  const createCart = async (item, index) => {
    const itemWeight = weight[item.id] || 1;
    const itemQty = qty[item.id] || 1;
    const itemMetrics = item.metrics || 'lbs';
  
    try {
      const cart = {
        entityId: item.id,
        ldapTitle: item.name,
        entityIdToQty: {
          [item.id]: {
            qty: itemQty,
            weight: itemWeight,
            metrics: itemMetrics
          }
        }
      };
  
      const localCartId = (item.cartId && tokenLoaded) ? item.cartId : cartId || localStorage.getItem('CART-ID');
      setCartId(localCartId);
  
      let url;
      if (tokenLoaded) {
        url = (cartId || localCartId) ? `${baseUrl}/cart/${localCartId}` : `${baseUrl}/cart`;
      } else {
        url = (cartId || localCartId) ? `${baseUrl}/cart/anonymous/${localCartId}` : `${baseUrl}/cart/anonymous`;
      }
  
      let response;
      let latLngQuery = location ? `?latitude=${location.latitude}&longitude=${location.longitude}` : `?ipAddress=${ipAddress}`;
      url = url + latLngQuery;
  
      if (localCartId) {
        // Update the existing cart
        response = await axios.put(url, cart);
      } else {
        // Create a new cart
        response = await axios.post(url, cart);
  
        const newCartId = response.data.id;
        setCartId(newCartId);
        localStorage.setItem('CART-ID', newCartId);
      }
  
      setSelectedItemId(item.id);
      const newAddedEntities = response?.data?.entities 
        ? new Set(response?.data?.entities?.map(entity => entity.id)) 
        : new Set(Object.keys(response?.data?.entityIdToQty || {}));
      
      setAddedEntities(newAddedEntities);
      const count = response.data?.entities 
        ? response.data.entities.length 
        : (response.data?.entityIdToQty ? Object.keys(response.data.entityIdToQty).length : 0);
  
      setCartCount(count);
      setAlertForeCartItemAdded(true);
    } catch (error) {
      console.error('Error creating or updating cart:', error);
    }
  };
  


  const fetchItems = useCallback(async (domainIdf) => {
setIsSubmitting(true);
    setCategoryId(selectedCategoryId);
    try {
    
     let url =  `${baseUrl}/entities/byhost`;
      let latLngQuery = "";
      if (location) {
        console.log(`Latitude: ${location.latitude}, Longitude: ${location.longitude}`);
        latLngQuery = `?latitude=${location.latitude}&longitude=${location.longitude}`;
      } else {
        latLngQuery = `?ipAddress=${ipAddress}`;
        if (!ipAddress) {
          return;
        }
      }
      url = url + latLngQuery;

      const response = await axios.get(url);
      const items = response.data;
      const categoryGroups = getCategoryGroups(items);
      const groupedItemsData = Object.entries(categoryGroups)?.map(([category, items]) => ({ category, items }));

      const foundCategoryData = groupedItemsData.find(item => item.category.toLowerCase() === selectedCategoryId.toLowerCase());

      const cartUrl = tokenLoaded ? `${baseUrl}/cart` : (cartId && tokenLoaded) ? `${baseUrl}/cart/${cartId}` : cartId && `${baseUrl}/cart/anonymous/${cartId}`;
      setCategoryData(foundCategoryData);
      if (cartUrl) {
        const cartResponse = await axios.get(cartUrl);
        const cart = cartResponse.data;
        if (cart && cart.entityIdToQty) {
          const count = Object.keys(cart.entityIdToQty).length;
          const newAddedEntities = new Set(Object.keys(cart.entityIdToQty || {}));
          setAddedEntities(newAddedEntities);
          setCartCount(count);
          setCartId(cart.id);
          setCartCount(count);
        }else{
          localStorage.setItem("CART-ID", '');
        }
      }
    } catch (error) {
      console.error("Error in fetchItems: ", error);  // log the error
    }
    setIsSubmitting(false);
  }, []);
  



  function getCategoryGroups(items) {
    return items.reduce((groups, item) => {
      if (item.images && item.images.length > 0) {
        item.image = item.images[0];
      }
      if (item.categoryIdToName) {
        Object.entries(item.categoryIdToName).forEach(([categoryId, categoryName]) => {
          const categoryGroup = groups[categoryName] || [];
          categoryGroup.push(item);
          groups[categoryName] = categoryGroup;
        });
      }
      return groups;
    }, {});
  }

  const [viewItem, setViewItem] = useState(null);
  const [addNewModalOpen, setAddNewModalOpen] = useState(false);

  const toggleAddNewModal = () => {
    setAddNewModalOpen(!addNewModalOpen);

  };
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const toggleViewModal = () => {
    setViewModalOpen(!viewModalOpen);
  };
  const handleViewModalClose = () => {

    toggleViewModal();
  };


  const scrollToSection = () => {
    if (sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  useEffect(() => {
    if(isSubscribe) {
   
    scrollToSection();
    }
  }, [isSubscribe])

  useEffect(() => {
    if(!isSubmitting) {
   
    fetchItems();
    }
  }, []);

  return (

    <section className="mb-2 position-relative grainy-gradient-intro justify-content-center text-center">
      {contactPage && <ContactModal />}
      {isPageDataEmpty ?

        <MDBSpinner className='m-5'>
          <span className='visually-hidden'>Loading...</span>
        </MDBSpinner> : <>

{!tokenLoaded && 
          <section >
            <style>
              {`
      .cascading-right {
        margin-right: -50px;
      }
      @media (max-width: 991.98px) {
        .cascading-right {
          margin-right: 0;
        }
      }
    `}
              {`
      .cascading-left {
        margin-left: -30px;
      }
      @media (max-width: 991.98px) {
        .cascading-left {
          margin-left: 0;
        }
      }
    `}
            </style>

            <div className="container py-1">
              <div className="row justify-content-center align-items-center">
                <section>

                  <div id="intro1">
                    <MDBContainer fluid className="h-100">
                      <MDBRow className="align-items-center justify-content-center text-center h-80 mb-5">
                        <MDBCol sm={4} lg={3} xl={6} className="mt-5">
                          <figure className='text-center mb-0'>
                            <MDBTypography blockquote>
                              <h1 className="display-3 fw-bold mb-0" style={{ color: '#7f00ee' }} dangerouslySetInnerHTML={{ __html: pageData?.cta }}></h1>
                            </MDBTypography>
                            <figcaption className='blockquote-footer mb-0'>
                              <cite title='Source Title' style={{ color: '#000000' }} dangerouslySetInnerHTML={{ __html: pageData?.cite }}></cite>
                            </figcaption>
                          </figure>


                          {/* <MDBBtn color="danger" size="lg" className="btn-rounded bg-opacity-75 bg-black">
                Get in touch
              </MDBBtn> */}

                          <MDBBtn size='lg' className='btn-rounded mx-1 mb-2 mt-3 bg-warning text-black bg-opacity-75' onClick={() => setContactPage(true)}>  {tokenLoaded ? pageData?.banner?.contactButton?.whenLoggedin : pageData?.banner?.contactButton?.labelText}  <MDBAnimation
                            infinite
                            tag='i'
                            animation='zoom-in'
                            className='fas fa-question'
                            start='onLoad'
                            duration={delayOfAnimation}
                          /></MDBBtn>


                          <MDBBtn size='lg' className='btn-rounded mx-1 mb-2 mt-3 text-white bg-blue bg-opacity-75' onClick={scrollToSection}>BUY  <MDBAnimation
                            infinite
                            tag='i'
                            animation='zoom-in'
                            className='fas fa-question'
                            start='onLoad'
                            duration={delayOfAnimation}
                          /></MDBBtn>


                          <MDBBtn size='lg' className='btn-rounded mx-1 mb-2 mt-3  bg-secondary text-primary bg-opacity-75'> <Link to='/home' className='m-1' >

                            <MDBTypography tag='strong'>features  <MDBAnimation
                              infinite
                              tag='i'
                              animation='zoom-in'
                              className='fas fa-check'
                              start='onLoad'
                              duration={delayOfAnimation}
                            /></MDBTypography>

                          </Link></MDBBtn>
                        </MDBCol>
                        <MDBCol lg={6} xl={6} className='d-inline-block '>

                          <img
                            src="https://opengrit.com/images/expenceLandingImage"
                            alt=""
                            className="img-fluid"
                          />


                          <MDBBtn size='lg' color='success' tag='a' outline style={{ top: '50px' }} className='btn-rounded' onClick={scrollToSection}>
                            <MDBAnimation
                              infinite
                              slower={true}
                              tag='i'
                              animation='zoom-in'
                              style={{ color: 'black' }}
                              className='fas fa-check ,color: black'
                              start='onLoad'
                              duration={25500}
                              dangerouslySetInnerHTML={{ __html: pageData?.sale }}
                            />
                            <MDBBadge color='warning' pill >Click Here</MDBBadge>
                          </MDBBtn>



                        </MDBCol>

                      </MDBRow>

                      <MDBRow>
                        <figure className='text-center mb-3'>
                          <MDBTypography blockquote>
                            <p><h3 className="text-center  text-black">{pageData?.banner?.text2?.textValue}</h3></p>
                          </MDBTypography>
                          <figcaption className='blockquote-footer mb-0 ms-5 text-light'>
                            <cite title='Source Title'> {pageData?.banner?.text3?.textValue}</cite>
                          </figcaption>
                        </figure>

                        <MDBRow className='justify-content-center align-items-center'>
  {pageData?.mainMessages?.map((message, index) => (
    <MDBCol 
      key={index} 
      lg="3" 
      md="6" 
      sm="12" 
      className='d-flex justify-content-center align-items-center text-center mb-4'>
      
      <div className="d-flex flex-column flex-md-row align-items-center text-center">
        <img 
          src={`https://opengrit.com/images/${message}`} 
          className="img-fluid mb-2 mb-md-0" 
          style={{ height: '45px', marginRight: '10px' }} 
          alt="Description" 
        />
        <h5 
          // className={`ms-2 ${message === 'Insights' || message === 'Audit' ? 'text-black' : 'text-light'}`}
          className='ms-2 text-black'
          style={{ wordWrap: 'break-word' }}>
          {message}
        </h5>
      </div>
      
    </MDBCol>
  ))}
</MDBRow>

                      </MDBRow>
                    </MDBContainer>
                  </div>
                  {/* Intro */}
                </section>

              </div>
            </div>
            
          </section>
}

         {categoryData?.items?.length>0 ?  <section>
            <p className="display-4 fw-bold ls-tight mb-2 mt-5 text-capitalize" style={{ color: '#e45300' }}>{categoryId}</p>         
            <MDBRow className='d-flex row-cols-1 row-cols-md-2 g-1 justify-content-center mt-2' ref={sectionRef}>  {
                categoryData?.items?.map((item, index) => (
                  displayEntities(index, item)
                ))
              }
            </MDBRow>
            <ItemView key={`ItemView-${viewModalOpen}`} item={viewItem} show={viewModalOpen} handleViewModalClose={handleViewModalClose} createCart={createCart} weight={weight} setWeight={setWeight}  qty={{ items: qty }}  setQty={setQty} />
            <AddNewEntity show={addNewModalOpen} handleAddModalClose={toggleAddNewModal}
            />

          </section> : 
          
        <MDBSpinner className='m-5'>
        <span className='visually-hidden'>Loading...</span>
      </MDBSpinner>
          }
        </>}

        <Testimonials/>
    </section>


  );

  function displayEntities(index, item) {
    return <MDBCol lg="4" md="12" className="mb-lg-0 mb-4 d-flex justify-content-center align-items-center" key={index}>
      <MDBCard className="text-light text-center">
        <MDBCardHeader className="text-dark justify-content-center align-items-center">
          <h4
            className="text-truncate text-center d-flex  justify-content-center align-items-center"
            style={{
              padding: "2.5rem",
              marginBottom: 0,
              fontWeight: 500,
              maxWidth: 300
            }}
          >  <div className="d-flex  justify-content-center align-items-center  " >


            {item.imageIds && item.imageIds.length > 0 && (
  <img
    src={item.thumbnails[item.imageIds.length - 1]}
    alt=""
    style={{ width: '80px', height: '80px' }}
  />
)}


              <span className="fw-bold mb-1 me-0 ms-2  text-capitalize "> {item && item.name ? item.name : ''}</span>


            </div>
          </h4>

          {/* disabled={selectedItemId && selectedItemId !== item.id} */}
          {item.name === localStorage.getItem("SUBSCRIPTION") ? <h6>Current Subscription</h6> : 
          
          <MDBBtn block color={item.buttonColor} onClick={() => createCart(item, item.id)} >  
            Subscribe
          </MDBBtn>
          }

          
          <MDBAlert open={alertForeCartItemAdded} color='warning' autohide position={position} delay={2000} appendToBody>
            Item Added to Cart <MDBBtn tag='a' color='none' className='m-1' style={{ color: '#3b5998' }} onClick={() => setAlertForeCartItemAdded(false)}><MDBIcon fas color='red' icon="check-circle" /></MDBBtn>
          </MDBAlert>
        </MDBCardHeader>
        <MDBCardBody className="striped green-striped text-dark px-5">

          <h2 className='text-center'><span className="fs-6" style={{ color: 'red' }}>{item.currencySymbol}</span>{ parseInt(item?.discountedPrice, 10) === 0 ? item?.originalPrice : item.discountedPrice}/<span className='fs-6'>yr</span>  { <strong className='text-success fs-3'><span className={parseInt(item?.discountedPrice, 10) !== 0 && 'text-decoration-line-through'}> {item?.originalPrice}</span></strong>}</h2>
         

          {/* <span style={{ position: 'relative', top: -55, right: -15, color: 'red' }}>
            <h6>{item.currencySymbol}</h6>
          </span> */}
          {item?.features?.map((feature, featureIndex) => (
            <p key={featureIndex} style={{ textAlign: 'left' }}>
              <MDBIcon fas icon={feature.icon} className="me-4" />
              {feature.textValue}
            </p>
          ))}
        </MDBCardBody>
      </MDBCard>
    </MDBCol>


  }
}
export default ExpensesLanding;